const __DEV__ = false;

var data = { type:{ fontSize:{ "default":14,
      page:16 },
    fontFamily:"Cabin, 'Open Sans', sans-serif",
    fontFamilyBody:"'Open Sans', sans-serif",
    fontWeight:{ light:300,
      regular:400,
      medium:500,
      semiBold:600,
      bold:700 },
    h1:{ fontSize:40,
      fontFamily:"Cabin, 'Open Sans', sans-serif",
      fontWeight:700,
      lineHeight:1.25 },
    h2:{ fontSize:36,
      fontFamily:"Cabin, 'Open Sans', sans-serif",
      fontWeight:700,
      lineHeight:1.222222222222222 },
    h3:{ fontSize:32,
      fontFamily:"Cabin, 'Open Sans', sans-serif",
      fontWeight:700,
      lineHeight:1.25 },
    h4:{ fontSize:24,
      fontFamily:"Cabin, 'Open Sans', sans-serif",
      fontWeight:700,
      lineHeight:1.25 },
    h5:{ fontSize:16,
      fontFamily:"Cabin, 'Open Sans', sans-serif",
      fontWeight:700,
      lineHeight:1.5 },
    h6:{ fontSize:14,
      fontFamily:"Cabin, 'Open Sans', sans-serif",
      fontWeight:700,
      lineHeight:1.571428571428571 },
    body1:{ fontSize:18,
      fontFamily:"'Open Sans', sans-serif",
      fontWeight:400,
      lineHeight:1.444444444444444 },
    body2:{ fontSize:16,
      fontFamily:"'Open Sans', sans-serif",
      fontWeight:400,
      lineHeight:1.5 },
    body3:{ fontSize:14,
      fontFamily:"'Open Sans', sans-serif",
      fontWeight:400,
      lineHeight:1.571428571428571 },
    body4:{ fontSize:12,
      fontFamily:"'Open Sans', sans-serif",
      fontWeight:400,
      lineHeight:1.333333333333333 },
    body5:{ fontSize:12,
      fontFamily:"'Open Sans', sans-serif",
      fontWeight:400,
      lineHeight:1.333333333333333 },
    body6:{ fontSize:12,
      fontFamily:"'Open Sans', sans-serif",
      fontWeight:400,
      lineHeight:1.333333333333333 },
    label:{ fontSize:12,
      fontFamily:"'Open Sans', sans-serif",
      fontWeight:600,
      lineHeight:1.333333333333333,
      textTransform:"uppercase" } } };

var typography = data;
data.type;

export { typography as default };
//# sourceMappingURL=typography.yaml.js.map
